import { PageRequest } from '@/core/request/PageRequest';

export enum PlanAccountClassification {
  Fixed = 'FIXED',
  Variable = 'VARIABLE',
  withoutClassification = 'WITHOUTCLASSIFICATION',
}

export enum PlanAccountDestination {
  Revenue = 'REVENUE',
  Expense = 'EXPENSE',
}

export enum PlanAccountHierarchy {
  Syntetics = 'SYNTETICS',
  Analitical = 'ANALITICAL',
}

export enum PlanAccountOrderBy {
  CODE = 'CODE',
  DESCRIPTION = 'DESCRIPTION',
}

export enum PlanAccountType {
  General = 'GENERAL',
  Tax = 'TAX',
  Transfer = 'TRANSFER',
  Commission = 'COMMISSION',
  Estorno = 'ESTORNO',
  Tariff = 'TARIFF',
}

export interface PlanAccountProfile {
  id: number;
  companiesId: number[];
  planAccountId: number;
  profileId: number;
}

export interface PlanAccount {
  classification: PlanAccountClassification;
  code: string;
  description: string;
  destination: PlanAccountDestination;
  hierarchy: PlanAccountHierarchy;
  id: number;
  matrixId: number;
  planAccountProfileCollection: PlanAccountProfile[];
  type: PlanAccountType;
  active: boolean;
}

export interface CreatePlanAccountRequest {
  active: boolean;
  classification: PlanAccountClassification;
  code: string;
  description: string;
  destination: PlanAccountDestination;
  hierarchy: PlanAccountHierarchy;
  planAccountProfileCollection: PlanAccountProfile[];
  type: PlanAccountType;
}

export interface UpdatePlanAccountRequest {
  active: boolean;
  id: number;
  classification: PlanAccountClassification;
  code: string;
  description: string;
  destination: PlanAccountDestination;
  hierarchy: PlanAccountHierarchy;
  planAccountProfileCollection: PlanAccountProfile[];
  type: PlanAccountType;
}

export interface ListPlanAccountsQuery extends PageRequest {
  active?: boolean;
  classification?: PlanAccountClassification;
  search?: string;
  code?: string;
  description?: string;
  destination?: PlanAccountDestination;
  hierarchy?: PlanAccountHierarchy;
  type?: PlanAccountType;
  orderBy?: PlanAccountOrderBy;
}

export interface PlanAccountImport {
  code: string;
  description: string;
  hierarchy: PlanAccountHierarchy;
  destination?: PlanAccountDestination;
  type?: PlanAccountType;
  classification?: PlanAccountClassification;
  subPlanAccounts?: SubPlanAccountImport[];
}

export interface PlanAccountSelected extends SubPlanAccountImport {
  parent: {
    code: string;
    description: string;
    hierarchy: PlanAccountHierarchy;
    destination: PlanAccountDestination;
    classification?: PlanAccountClassification;
    type: PlanAccountType;
  };
}

export interface SubPlanAccountImport {
  code: string;
  description: string;
  hierarchy: PlanAccountHierarchy;
  destination: PlanAccountDestination;
  classification?: PlanAccountClassification;
  type: PlanAccountType;
}

export interface PlanAccountImportValues {
  code: string;
  description: string;
  hierarchy: PlanAccountHierarchy;
  key: string;
  active: true;
  destination: PlanAccountDestination;
  type: PlanAccountType;
  classification?: PlanAccountClassification;
}

export interface PlanAccountImportCreateRequest {
  planAccountRequestDTOs: PlanAccountImportValues[];
}
